import * as THREE from "three";

// Shared spherical "window" around the selected body zone
export const CLIP = { center: { value: new THREE.Vector3() }, radius: { value: 0 } };

const injectPos = (shader) => {
  shader.uniforms.uClipC = CLIP.center;
  shader.uniforms.uClipR = CLIP.radius;
  shader.vertexShader = "varying vec3 vClipPos;\n" + shader.vertexShader.replace("#include <project_vertex>",
    "#include <project_vertex>\nvClipPos = (modelMatrix * vec4(transformed, 1.0)).xyz;");
  shader.fragmentShader = "uniform vec3 uClipC;\nuniform float uClipR;\nvarying vec3 vClipPos;\n" + shader.fragmentShader;
};

const atStart = (shader, code) => {
  shader.fragmentShader = shader.fragmentShader.replace("#include <clipping_planes_fragment>", `#include <clipping_planes_fragment>\n${code}`);
};

// Keep only fragments inside the window (internal layers)
export const clipInside = (shader) => {
  injectPos(shader);
  atStart(shader, "if (uClipR > 0.0 && distance(vClipPos, uClipC) > uClipR) discard;");
};

// Skin outside the window stays opaque; a thin teal ring marks the edge
export const clipOutside = (shader) => {
  injectPos(shader);
  atStart(shader, "float clipD = distance(vClipPos, uClipC);\nif (uClipR > 0.0 && clipD < uClipR) discard;");
  shader.fragmentShader = shader.fragmentShader.replace("#include <emissivemap_fragment>",
    "#include <emissivemap_fragment>\nif (uClipR > 0.0) totalEmissiveRadiance += vec3(0.05, 0.55, 0.5) * (1.0 - smoothstep(0.0, uClipR * 0.05, clipD - uClipR));");
};
